import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import InfoMessage from "../../Shared/InfoMessage";
import { computed, inject, onMounted, ref, watch } from "vue";
import {
  configsProviderKey,
  type ConfigsNavigationPath,
} from "../../../infrastructure/configs_provider";
import { useRouter, useRoute } from "vue-router";
import ConfigsNavigation from "../ConfigsNavigation";
import Cart from "../../Shared/Cart";

import ConfigsAccess from "../ConfigsAccess";
import ConfigsMobile from "../ConfigsMobile";
import ConfigsPhone from "../ConfigsPhone";
import ConfigsTv from "../ConfigsTv";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default {
  template: html,
  components: {
    InfoMessage,
    ConfigsAccess,
    ConfigsMobile,
    ConfigsPhone,
    ConfigsTv,
    ConfigsNavigation,
    Cart,
  },
  setup() {
    // Injections
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const configsProvider = inject(configsProviderKey);
    const configsPathes = computed<ConfigsNavigationPath[]>(() => {
      return configsProvider?.configsPathes.value ?? [];
    });
    const currentPath = computed(() => {
      const currentIndex = configsPathes.value.findIndex(
        (p) => p.path == route.path,
      );
      const current = configsPathes.value[currentIndex];
      return current;
    });

    const currentPathString = computed(() => currentPath.value?.path || "");

    // während des Klicks auf 'next' läuft validate() ggf. noch auf einen offenen
    // Autosave-Request der Kinder; solange den Button sperren (Doppelklick-Schutz + Feedback)
    const isValidating = ref(false);

    // methods
    const back = function(){
      const currentIndex = configsPathes.value.findIndex((p) => p.path == route.path);
      const last = configsPathes.value[currentIndex - 1] 
      if (last){
        router.push(last.path);
      } else {
        router.push("/options");
      }
    }

    const next = function(){
      const currentIndex = configsPathes.value.findIndex((p) => p.path == route.path);
      const next = configsPathes.value[currentIndex + 1] 
      if (next){
        router.push(next.path);
      } else {
        router.push("/customerdata");
      }
    }

    const handleOptionsPath = () => {
      if ("/configs" == route.path) {
        const first = configsPathes.value[0];
        if (first) {
          router.push(first.path);
        } else {
          router.push("/configs");
        }
      }
    };

    onMounted(() => {
      // /options is just the container -> move to the first option page
      handleOptionsPath();
    });

    watch(
      () => route.path,
      () => {
        handleOptionsPath();
      },
    );
    return {
      t,
      currentPathString,
      next,
      back,
      isValidating,
    };
  },
};
